export default {
  contact: {
    hero: {
      eyebrow: 'اتصل بنا',
      title: 'تواصل معنا',
      lead: 'سواء معلومات أولية أو تخطيط ملموس أو معاينة في الموقع – نتطلع إلى رسالتك.',
    },
    info: {
      partner: 'شريكك في تقنية الأمان',
      owner: 'المالك',
      address: 'العنوان',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
      hours: 'ساعات العمل',
      area: 'منطقة الخدمة',
      viewAreas: 'عرض جميع مناطق الخدمة',
    },
    form: {
      title: 'طلب مشروع',
      lead: 'املأ النموذج. سنرد عليك قريبًا.',
      customerType: 'خاص أو شركة *',
      select: 'الرجاء الاختيار',
      privat: 'خاص',
      gewerbe: 'شركة',
      name: 'الاسم *',
      company: 'الشركة',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني *',
      projectLocation: 'موقع المشروع',
      objectType: 'نوع المبنى',
      objEfh: 'منزل عائلي',
      objMfh: 'عمارة سكنية',
      objLaden: 'تجزئة / متجر',
      objBuero: 'مكتب / عيادة',
      objGastronomie: 'مطعم',
      objLager: 'مستودع / لوجستيات',
      objWerkstatt: 'ورشة / حرف',
      objSonstige: 'أخرى',
      service: 'الخدمة المطلوبة',
      svcBeratung: 'استشارة أولى',
      svcPlanung: 'تخطيط وعرض',
      svcInstallation: 'تركيب وإعداد',
      svcErweiterung: 'توسعة نظام قائم',
      svcWartung: 'صيانة / عناية',
      svcCare: 'طلب SSG Care',
      systemStatus: 'حالة النظام',
      stNeu: 'نظام جديد',
      stBestehend: 'توسعة نظام قائم',
      stAustausch: 'استبدال كامل',
      stUnsicher: 'غير متأكد بعد',
      message: 'الرسالة',
      messagePlaceholder: 'صف مشروعك أو أسئلتك باختصار...',
      maxChars: 'حد أقصى 500 حرف',
      fileUpload: 'رفع ملف',
      fileHint: 'صور أو مخططات أو مستندات أخرى (اختياري)',
      fileNote: 'ملاحظة: تُعامل الملفات المرفوعة على أنها «غير قابلة للجمع».',
      callback: 'وقت معاودة الاتصال المفضل',
      callbackNone: 'لا رغبة في معاودة الاتصال',
      vormittag: 'صباحًا',
      nachmittag: 'بعد الظهر',
      abend: 'مساءً',
      consent: 'قرأت سياسة الخصوصية وأوافق على معالجة بياناتي لمعالجة هذا الطلب. *',
      success: 'شكرًا لطلبك. سنرد عليك قريبًا.',
      submit: 'إرسال الطلب',
      submitting: 'جارٍ الإرسال...',
    },
  },
};